/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CrudList } from 'app/components/organisms/crud/crud-list';
import { CrudAdd } from 'app/components/organisms/crud/crud-add';
import { CrudEdit } from 'app/components/organisms/crud/crud-edit';
import { useProjectRole } from 'app/hooks/use-project-role';
import { createProjectMovementsTemplate } from './form-config';
import { appRoutes } from 'app/routes';

/**
 * Use movements template with role awareness.
 */

function useMovementsTemplate() {
  const [translate] = useTranslation();
  const role = useProjectRole();
  const isOwner = !role || role === 'owner';

  return useMemo(() => createProjectMovementsTemplate(translate, isOwner), [translate, isOwner]);
}

/**
 * Movements CRUD components with role-aware template.
 */

function MovementsCrudList() {
  const template = useMovementsTemplate();

  return <CrudList template={template} />;
}

function MovementsCrudAdd() {
  const template = useMovementsTemplate();

  return <CrudAdd template={template} />;
}

function MovementsCrudEdit() {
  const template = useMovementsTemplate();

  return <CrudEdit template={template} />;
}

/**
 * Export `movementsCrudRoutes`.
 */

export function movementsCrudRoutes() {
  const route = appRoutes.dashboard.projects.project.movements;

  return (
    <>
      <Route Component={MovementsCrudList} id={route} path={route} />
      <Route Component={MovementsCrudAdd} id={`${route}/add`} path={`${route}/add`} />
      <Route Component={MovementsCrudEdit} id={`${route}/edit/:id`} path={`${route}/edit/:id`} />
    </>
  );
}
